import { lazy } from 'react';
import { authRoles } from 'app/auth';
import { PlusFeatureGate } from 'app/shared-components/PlusPaywall';
import InAppBannersPaywall from './components/InAppBannersPaywall';

const InAppBannersPage = lazy(() => import('./InAppBannersPage'));

const InAppBannersConfig = {
  settings: {
    layout: {
      config: {
        topBanner: {
          display: false,
        },
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
            background: 'featured',
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'in-app-banners',
      element: (
        <PlusFeatureGate
          feature="inAppBanners"
          title="In-App Banner"
          paywall={<InAppBannersPaywall />}
        >
          <InAppBannersPage />
        </PlusFeatureGate>
      ),
    },
  ],
};

export default InAppBannersConfig;
